<template>
    <component
        v-if="data.type"
        :is="illustrationComponent"
        :style="{
            color: primaryColor,
            '--illustration-primary-color': primaryColor,
            '--illustration-accent-color': accentColor,
        }"
        :text="text"
        aria-hidden="true" />
</template>

<script lang="ts">
    import { defineComponent, PropType, computed, h } from 'vue';
    import { Type, IllustrationData } from './Illustration.interfaces';
    import { COLORS } from './Illustration.helpers';
    import * as Illustrations from '@ui/components/Illustration/Illustration.imports';

    export default defineComponent({
        name: 'Illustration',
        props: {
            data: {
                type: Object as PropType<IllustrationData>,
                required: true,
            },
            text: { type: Array as PropType<string[]>, default: [] as string[] },
        },
        setup(props) {
            const primaryColor = computed<string | undefined>(() =>
                props.data?.primary ? COLORS[props.data.primary] : COLORS['violet']
            );

            const accentColor = computed<string | undefined>(() =>
                props.data?.accent ? COLORS[props.data.accent] : COLORS['purple']
            );

            const illustrationComponent = computed(() => getComponent(props.data.type));

            const getComponent = (type: Type) => {
                // eslint-disable-next-line import/namespace
                const dynamicIllustration = Illustrations[type];
                if (!dynamicIllustration) {
                    console.error(`Illustration component not found for type: ${type}`);
                    return null;
                }

                return {
                    render() {
                        return h(dynamicIllustration, {
                            class: 'illustration-svg',
                        });
                    },
                };
            };

            return {
                primaryColor,
                accentColor,
                illustrationComponent,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Illustration.scss';
</style>
